/**
 * @generated SignedSource<<dc4545e4831dee59af3e1fc74442c624>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ActionsCell$data = {
  readonly id: string;
  readonly jiraProjectName: string;
  readonly jiraProjectType: JiraProjectType | null | undefined;
  readonly key: string;
  readonly projectStyle: JiraProjectStyle | null | undefined;
  readonly " $fragmentType": "ActionsCell";
};
export type ActionsCell$key = {
  readonly " $data"?: ActionsCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionsCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ActionsCell",
  "selections": [
    {
      "alias": "jiraProjectType",
      "kind": "ScalarField",
      "name": "projectType"
    },
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "alias": "jiraProjectName",
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b50fdd1e787bf895dcccd80a1a947a46";

export default node;
